export interface PredictionWithApproval {
  predictedValue: string | undefined | null; // undefined: not yet predicted, null: no prediction available
  selectedValue: string | null; // null if no alternative selected
  isApproved: boolean | null; // null: not yet decided, true: approved, false: rejected
}

export type MaterialDecision = {
  status: 'approved' | 'overridden' | null;
  selectedMaterial: string | null;
};

export function getMaterialDecision(approval: PredictionWithApproval): MaterialDecision {
  // user accepted the prediction
  if (approval.isApproved === true && approval.selectedValue === null && approval.predictedValue) {
    return { status: 'approved', selectedMaterial: approval.predictedValue };
  }
  // user supplied the material themselves (rejected the prediction, none was available, or no image matched)
  if (approval.selectedValue) {
    return { status: 'overridden', selectedMaterial: approval.selectedValue };
  }
  // No material decision.
  return { status: null, selectedMaterial: null };
}
